import React from "react";

const OldClasses = () => {
	return <></>;
};

export default OldClasses;